var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer centralizar",class:{ 'footer_left': _vm.isActive }},[_vm._v("\n      Copyright © com   "),_c('i',{staticClass:"far fa-heart"}),_vm._v("  por Farsoft Systems  \n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }